(function () {
  function mount() {
    const field = document.getElementById('AelizaGateEmail');
    if (!field || field.dataset.aelizaGateCaret === 'yes') return;

    const parent = field.parentNode;
    const wrap = document.createElement('div');
    wrap.className = 'aeliza-gate__email-wrap';
    parent.insertBefore(wrap, field);
    wrap.appendChild(field);

    const mirror = document.createElement('span');
    mirror.className = 'aeliza-gate__caret-mirror';
    mirror.setAttribute('aria-hidden', 'true');
    wrap.appendChild(mirror);

    const cursor = document.createElement('span');
    cursor.className = 'aeliza-gate__caret';
    cursor.setAttribute('aria-hidden', 'true');
    wrap.appendChild(cursor);
    field.dataset.aelizaGateCaret = 'yes';

    const placeholder = field.getAttribute('placeholder') || '';
    let raf = 0;

    function place() {
      raf = 0;
      if (document.activeElement !== field) return;
      const style = getComputedStyle(field);
      // Match the actual CSS-rendered input (including text-transform and letter spacing).
      for (const prop of [
        'fontFamily', 'fontSize', 'fontWeight', 'fontStyle', 'fontStretch',
        'fontVariant', 'fontKerning', 'letterSpacing', 'textTransform',
        'textRendering', 'wordSpacing'
      ]) {
        mirror.style[prop] = style[prop];
      }
      const caretAt = typeof field.selectionStart === 'number'
        ? field.selectionStart : field.value.length;
      mirror.textContent = field.value.slice(0, caretAt);
      const advance = mirror.getBoundingClientRect().width;
      const leftBorder = parseFloat(style.borderLeftWidth) || 0;
      const rightBorder = parseFloat(style.borderRightWidth) || 0;
      const leftPadding = parseFloat(style.paddingLeft) || 0;
      const rightPadding = parseFloat(style.paddingRight) || 0;
      const minX = leftBorder + leftPadding;
      const maxX = Math.max(minX, field.clientWidth - rightBorder - rightPadding - cursor.offsetWidth);
      // Native input scrollLeft also handles long email addresses.
      const x = Math.max(minX, Math.min(maxX, minX + advance - field.scrollLeft));
      cursor.style.left = x + 'px';
    }

    function queue() {
      if (!raf) raf = requestAnimationFrame(place);
    }
    field.addEventListener('focus', function () {
      field.setAttribute('placeholder', '');
      field.style.setProperty('caret-color', 'transparent', 'important');
      cursor.classList.add('is-visible');
      queue();
    });
    field.addEventListener('blur', function () {
      cursor.classList.remove('is-visible');
      field.style.removeProperty('caret-color');
      field.setAttribute('placeholder', placeholder);
    });
    for (const eventName of ['input', 'keyup', 'click', 'select', 'scroll', 'compositionend']) {
      field.addEventListener(eventName, queue);
    }
    document.addEventListener('selectionchange', function () {
      if (document.activeElement === field) queue();
    });
    window.addEventListener('resize', queue);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();